var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('BaiKong'),_c('BaiFooter'),_c('div',[_c('button',{on:{"click":_vm.getInfo}},[_vm._v("获取信息")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }